import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AudioMuteSVG, AudioUnmuteSVG } from '../../assets/SVGAssets';
import { setAudioDefaultState } from '../../store/sessionStatus';

export default function SoundSystem({ audioFile }) {
    const dispatch = useDispatch();
    const audio = useRef();
    const audioDefault = useSelector((state) => state.session.audioDefault);
    const [audioState, setAudioState] = useState(!audioDefault);

    const clickAudio = () => {
        setAudioState(!audioState);
        audioState && !audio.current.ended
            ? audio.current.play()
            : audio.current.pause();
        dispatch(setAudioDefaultState(audioState));
    };

    const onLoadHandler = () => {
        !audioState &&
            setTimeout(() => {
                audio.current.play();
            }, 500);
    };

    return (
        <div
            className="songButton"
            onClick={clickAudio}
            style={{
                display: `${audioFile ? 'flex' : 'none'}`,
            }}>
            {audioState ? <AudioMuteSVG /> : <AudioUnmuteSVG />}
            <audio
                onLoadedData={onLoadHandler}
                ref={audio}
                src={audioFile}></audio>
        </div>
    );
}
